import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/agent.service";
import {
  IAgent,
  ICreateAgent,
  IGetAgents,
  IUpdateAgent,
} from "../../models/agent.model";

// Async thunks
export const getAgentsThunk = createAsyncThunk(
  "agent/getAgents",
  async (payload: IGetAgents, { rejectWithValue }) => {
    try {
      const response = await api.getAgents(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get agents failed"
      );
    }
  }
);

export const getStatsAgentsThunk = createAsyncThunk(
  "agent/getStatsAgents",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.getStatsAgents();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get stats agents failed"
      );
    }
  }
);

export const createAgentThunk = createAsyncThunk(
  "agent/createAgent",
  async (payload: ICreateAgent, { rejectWithValue }) => {
    try {
      const response = await api.createAgent(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Create agent failed"
      );
    }
  }
);

export const duplicateAgentThunk = createAsyncThunk(
  "agent/duplicateAgent",
  async (payload: { id: string }, { rejectWithValue }) => {
    try {
      const response = await api.duplicateAgent(payload.id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Duplicate agent failed"
      );
    }
  }
);

export const getAgentByIdThunk = createAsyncThunk(
  "agent/getAgentById",
  async (payload: { id: string }, { rejectWithValue }) => {
    try {
      const response = await api.getAgentById(payload.id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get agent by id failed"
      );
    }
  }
);

export const updateAgentThunk = createAsyncThunk(
  "agent/updateAgent",
  async (
    payload: { id: string; payload: IUpdateAgent },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.updateAgent(payload.id, payload.payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Update agent failed"
      );
    }
  }
);

export const deleteAgentThunk = createAsyncThunk(
  "agent/deleteAgent",
  async (payload: { id: string }, { rejectWithValue }) => {
    try {
      const response = await api.deleteAgent(payload.id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Delete agent failed"
      );
    }
  }
);

export const getToolsThunk = createAsyncThunk(
  "agent/getTools",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.getTools();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get tools failed"
      );
    }
  }
);

export const createBaseKnowledgeThunk = createAsyncThunk(
  "agent/createBaseKnowledge",
  async (payload: { files: File[] }, { rejectWithValue }) => {
    try {
      const response = await api.createBaseKnowledge(payload.files);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Create base knowledge failed"
      );
    }
  }
);

export const getBaseKnowledgeThunk = createAsyncThunk(
  "agent/getBaseKnowledge",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.getBaseKnowledge();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get base knowledge failed"
      );
    }
  }
);